import { BackHeaderCombinedProps } from './types';

const usePresenter = (props: BackHeaderCombinedProps): BackHeaderCombinedProps => {
  return props;
};

export default usePresenter;
